<button type="button" class="btn btn--primary back-btn" (click)="back()" [title]="'SHARED.BACK-BTN' | translate"></button>
